import React from 'react';
import { Outlet } from 'react-router-dom';
import NavBar from './components/NavBar';
import BasicBreadcrumbs from './components/BasicBreadcrumbs';
import Box from '@mui/material/Box';
import Footer from './components/Footer';
import { LanguageProvider } from '../../services/localization/LanguageContex';
// import logo from "../../assets/background/bg2.png";

export default function HomeScreen() {
  return (
    <LanguageProvider>
      <Box 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '130vh', // full viewport height
  
        // backgroundImage: `url(${logo})`,
      }}
    >
      <NavBar />
      
      <Box sx={{ 
        // marginTop: '9px', 
        flexGrow: 1 }}>
        <BasicBreadcrumbs />
        <Outlet />
      </Box>

      <Footer />
    </Box>
    </LanguageProvider>
  );
}

